export default __webpack_public_path__ + "assets/images/e84778552f95344da280288f97c4b2e6.svg";